import { render, staticRenderFns } from "./ExerciseForm.vue?vue&type=template&id=0ea9bd7f&scoped=true&"
import script from "./ExerciseForm.vue?vue&type=script&lang=js&"
export * from "./ExerciseForm.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseForm.vue?vue&type=style&index=0&id=0ea9bd7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea9bd7f",
  null
  
)

export default component.exports